import React from 'react';
import { AlertDialog } from '@balance-web/modal-dialog';
import { Text } from '@balance-web/text';

type Props = {
  isOpen: boolean;
  id: string | undefined;
  onCancelConfirmation: () => void;
  onClose: () => void;
};

export const CancelConfirmationDialog = (props: Props) => {
  return (
    <AlertDialog
      actions={{
        confirm: {
          label: 'Yes, discard',
          action: () => {
            props.onClose();
            props.onCancelConfirmation();
          },
        },
        cancel: {
          label: 'Continue editing',
          action: props.onClose,
        },
      }}
      id={props.id}
      isOpen={props.isOpen}
      title="Discard changes?"
      tone="critical"
    >
      <Text>Changes you've made so far will not be saved.</Text>
    </AlertDialog>
  );
};
